export default {
  welcome: 'Welcome',
  shopsTitle: 'Shops',
  tapToJoin: 'Tap to join',
  shopJoinedLabel: 'You are here',
  tapToLeave: 'Tap again to leave',
  noShops: 'No shops yet.',
  loadShopsError: 'Could not load shops.',
  joinShopError: 'Could not join the shop. Please try again.',
  errorCreatingTale: 'Unexpected error creating a task',
  task: 'Task',
  taskExample1: 'Cleaning the bathroom',
  taskExample2: 'Meal prep',
  taskExample3: 'Supermarket run',
  taskExample4: 'Laundry',
}
